<template>
    <v-container
        v-if="isShowing"
        fluid
        class="flex-shrink-0 pa-0"
        style="background: #eee; min-height: 84px"
    >
        <v-row class="ma-0 pa-0 justify-space-around align-center">
            <slot />
        </v-row>
    </v-container>
</template>

<script>
/**
 * BottomButtonWrapper Component
 *
 * A bottom navigation wrapper that is part of the normal document flow.
 * Uses flex-shrink-0 to prevent shrinking and stays at the bottom of its parent flex container.
 *
 */
export default {
    name: "BottomButtonWrapper",
    props: {
        isShowing: {
            type: Boolean,
            default: true,
        },
    },
};
</script>
